<template>
    <div class="post-list">
        <div class="post-list__row row">
            <div class="post-list__single col" v-for="(post, index) in pageOfItems" :key="index">
                <a class="post-list__single__img" :href="post.url" :title="post.title">
                    <img :src="post.image" :alt="post.title">
                </a>
                <div class="post-list__single__wrapper">
                    <div class="post-list__single__meta heading-small">
                        BLOG POST {{ post.date }}
                    </div>
                    <a class="post-list__single__title" :href="post.url" :title="post.title">
                        <h4 ref="title" v-html="post.title"></h4>
                    </a>
                    <div v-if="post.authorName" class="post-list__single__author">
                        By {{ post.authorName }} <span v-if="post.authorDesc">- {{ post.authorDesc }}</span>
                    </div>
                    <div class="post-list__single__excerpt">
                        {{ post.excerpt }}
                    </div>
                </div>
            </div>
        </div>
        <jw-pagination
            :pageSize="8"
            :items="posts"
            :styles="customStyles"
            :labels="customLabels"
            @changePage="onChangePage"
            v-show="posts.length > 8"></jw-pagination>
    </div>
</template>
<script>
import { gsap } from 'gsap';
import SplitText from "gsap/SplitText";
gsap.registerPlugin(SplitText);

const customStyles = {
    ul: {
        display: '',
        margin: '',
        padding: ''
    },
    li: {
        display: '',
        padding: '',
        textAlign: '',
        listStyle: ''
    },
    a: {
        display: '',
        padding: '',
        float: '',
        cursor: ''
    }
};

const customLabels = {
    previous: '<',
    next: '>'
};

export default {
    name: "blog-posts",
    data() {
        return {
            pageOfItems: [],
            posts: [],
            customStyles,
            customLabels
        }
    },

    mounted() {
        this.getPosts()
    },

    methods: {
        onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;

            window.scroll(0,0);

            setTimeout(() => {
                const splitText = document.querySelectorAll('.post-list__single__title h4');

                splitText.forEach((item) => {
                    new SplitText(item, {type: "lines"})
                })
            }, 500)
        },
        getPosts() {
            this.axios.get('/wp-json/get/posts')
                .then((response) => {
                    this.posts = response.data.posts;
                })
        },
    },
}
</script>
<style lang="scss" scoped>

</style>